import React, { Component } from "react"
import { Card, CardBody, CardTitle, Media } from "reactstrap"
import { Link } from "react-router-dom"

const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

const today = new Date();
const yesterday = new Date();
yesterday.setDate(yesterday.getDate()-1);

const todayminus2 = new Date();
todayminus2.setDate(todayminus2.getDate()-2);

const todayminus3 = new Date();
todayminus3.setDate(todayminus3.getDate()-3);


const todayFormatted = (String(today.getDate()).padStart(2, '0')).concat(' ', month[today.getMonth()]);
const yesterdayFormatted = (String(yesterday.getDate()).padStart(2, '0')).concat(' ', month[yesterday.getMonth()]);
const todayminus2Formatted = (String(todayminus2.getDate()).padStart(2, '0')).concat(' ', month[todayminus2.getMonth()]);
const todayminus3Formatted = (String(todayminus3.getDate()).padStart(2, '0')).concat(' ', month[todayminus3.getMonth()]);

class ActivityComp extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

 

  render() {
    return (
      <React.Fragment>
        <Card>
          <CardBody>
            <CardTitle className="mb-5 h4">Agenda</CardTitle>
            <ul className="verti-timeline list-unstyled">
              <li className="event-list active">
                <div className="event-timeline-dot">
                <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="d-flex">
                  <div className="flex-shrink-0 me-3">
                    <h5 className="font-size-14">
                      {todayFormatted}{" "}
                      <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                    </h5>
                  </div>
                  <div className="flex-grow-1">
                    <div>Prospecting Block: West Coast</div>
                  </div>
                </div>
              </li>

              <li className="event-list">
                <div className="event-timeline-dot">
                  <i className="bx bx-right-arrow-circle font-size-18" />
                </div>
                <div className="d-flex">
                  <div className="flex-shrink-0 me-3">
                    <h5 className="font-size-14">
                    {yesterdayFormatted}{" "}
                      <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                    </h5>
                  </div>
                  <div className="flex-grow-1">
                    <div id="activitytext">
                        Account Research: target west market
                    </div>
                    <div>Customer Meeting: Oracle</div>
                  </div>
                </div>
              </li>
              <li className="event-list">
                <div className="event-timeline-dot">
                <i className="bx bx-right-arrow-circle font-size-18" />
                </div>
                <div className="d-flex">
                  <div className="flex-shrink-0 me-3">
                    <h5 className="font-size-14">
                      {todayminus2Formatted}{" "}
                      <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                    </h5>
                  </div>
                  <div className="flex-grow-1">
                    <div>Coaching Call: Odilia Alexandra</div>
                    <div>1-1: Amethyst Maya</div>
                  </div>
                </div>
              </li>
              <li className="event-list">
                <div className="event-timeline-dot">
                  <i className="bx bx-right-arrow-circle font-size-18" />
                </div>
                <div className="d-flex">
                  <div className="flex-shrink-0 me-3">
                    <h5 className="font-size-14">
                      {todayminus3Formatted}{" "}
                      <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                    </h5>
                  </div>
                  <div className="flex-grow-1">
                    <div>Customer Meeting: Macy&#39;s</div>
                    <div>Customer Meeting: Boscov&#39;s follow-up</div>
                    <div>Account Research: Retail</div>
                  </div>
                </div>
              </li>
            </ul>
          </CardBody>
        </Card>
      </React.Fragment>
    )
  }
}

export default ActivityComp
